import React, { FC } from 'react'
import { makeStyles, createStyles } from '@mui/styles'
import {
  Button,
  Dialog,
  DialogProps,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Box
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { LoadingButton } from '../Button/LoadingButton'

interface Props extends DialogProps {
  open: boolean
  title?: string
  customTitle?: React.ReactNode
  loading?: boolean
  error?: string
  onClose?: () => void
  cancelButton?: {
    title: string
    action: () => void
    disabled?: boolean
  }
  successButton?: {
    title: string
    action: () => void
    disabled?: boolean
  }
  slim?: boolean
  footer?: React.ReactNode
}

export const Modal: FC<Props> = ({
  children,
  open,
  title,
  customTitle,
  loading,
  error,
  onClose,
  cancelButton,
  successButton,
  footer,
  slim = false,
  ...modalProps
}) => {
  const styles = useStyles()

  // Determinar qué título mostrar
  const renderTitleContent = () => {
    if (customTitle !== undefined) {
      return customTitle
    }
    if (title) {
      return <Typography variant='h6'>{title}</Typography>
    }
    return null
  }

  const titleContent = renderTitleContent()
  const hasTitle = titleContent !== null

  return (
    <Dialog
      fullWidth={true}
      maxWidth='sm'
      {...modalProps}
      open={open}
      onClose={onClose}
    >
      <DialogTitle style={{ margin: 0, padding: '10px 1px 0px 23px' }}>
        <Box
          display='flex'
          justifyContent={hasTitle ? 'space-between' : 'flex-end'}
        >
          {/* Mostrar customTitle si existe, sino mostrar title normal */}
          {titleContent}
          {onClose && (
            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <DialogContent className={slim ? styles.slimDialog : ''}>
        {children}
        {error && (
          <Typography align='right' color='error'>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions className={slim ? styles.slimDialog : styles.dialogAction}>
        {cancelButton && (
          <Button
            variant='text'
            color='primary'
            onClick={cancelButton.action}
            disabled={cancelButton.disabled}
          >
            {cancelButton.title}
          </Button>
        )}
        {successButton && (
          <LoadingButton
            loading={loading}
            onClick={successButton.action}
            disabled={successButton.disabled}
          >
            {successButton.title}
          </LoadingButton>
        )}
      </DialogActions>
      {footer}
    </Dialog>
  )
}

const useStyles = makeStyles(
  createStyles({
    dialogAction: {
      display: 'flex',
      marginTop: 30
    },
    slimDialog: {
      padding: '0'
    }
  })
)
